import { useStore } from '@nanostores/react';

import useIsHydrated from '@klaviyo-mkt/gatsby-components/hooks/useIsHydrated';

import { $loggedIn } from '@academy/skilljar/stores/user';

import { Header } from '@klaviyo-mkt/gatsby-components/organisms/header';

import type { IHeader } from '@klaviyo-mkt/gatsby-components/organisms/header/types';

interface IStatefulSiteHeader extends Omit<IHeader, 'academyLoggedIn'> {
  ctasLoggedIn: IHeader['universalCtas'];
}

export const StatefulSiteHeader = ({
  ctasLoggedIn,
  universalCtas,
  ...props
}: IStatefulSiteHeader) => {
  const hasClientRendered = useIsHydrated();
  const loggedIn = useStore($loggedIn);

  return (
    <Header
      {...props}
      academyLoggedIn={hasClientRendered ? (loggedIn ?? false) : undefined}
      universalCtas={hasClientRendered ? universalCtas : undefined}
    />
  );
};
